import { BaseService } from '../../infra/base.service'
import type { Balance } from './balance'
import type { BalancesRepository } from './balances.repository'

export class BalancesService extends BaseService<Balance> {
    constructor(private rep: BalancesRepository) {
        super(rep)
    }
}
